export default __webpack_public_path__ + "static/media/enroll.dc9fbeb1.svg";